<template>
  <BundleReport
    v-if="chunkFunctions.application"
    :chunk="chunkFunctions"
  />
</template>

<script lang="ts">

import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import services from "@/composable/services";
import useObject from "@/composable/components/object";
import useArray from "@/composable/components/array";
import { LOCAL_STORAGE_LANG } from "@/services/Fetcher";
import { useResultProgress } from "@/composable/application/bundlReportComposable";
import BundleReport from "@/components/datas/report/BundleReport.vue";
import { LocalApplicationResult } from "@/types/front/LocalApplicationResult";
import { Chunk } from "@/types/front/ResultProgress";

interface Payload {
  results: {
    application: LocalApplicationResult;
    results: Chunk[];
    locale: string;
  };
  applicationName?: string;
  origin?: string;
}
export default {
  name: "BundleRapportView",
  components: { BundleReport },
  setup() {
    let locale: string;
    const { reactiveObject: application, doChangeObject: changeApplication } = useObject(
      new LocalApplicationResult(),
    );
    const message = ref("");
    const route = useRoute();
    const { reactiveObject: payload, doAddToObject: setpayload } = useObject<Payload>({});
    const { shallowRefArray: results, doChangeArray: setResults } = useArray<Chunk>([]);
    const applicationId = computed(() => route.params.applicationName);
    let chunkFunctions = ref(useResultProgress(new LocalApplicationResult(), "fr"));

    onMounted(() => {
      console.log("BundleReportView onMounted - window.name:", window.name.substring(0, 200));
      const parsed = JSON.parse(window.name) as Payload;
      console.log("Parsed payload:", parsed);
      setpayload(parsed);

      if (payload.results) {
        console.log("Processing results...");
        setResults(payload.results.results ?? []);
        console.log("Results count:", results.value.length);
        locale = payload.results.locale ?? "fr";
        localStorage.setItem(LOCAL_STORAGE_LANG, locale);
        const updatedApplication = services.internationalisationService.mergeInternationalization(payload.results.application);
        console.log("Updated application:", updatedApplication);
        if (typeof applicationId.value === "string") {
          updatedApplication.localRefName = services.internationalisationService.localeReferenceNames(
            applicationId.value,
            updatedApplication,
          ) || "";
        }
        changeApplication(updatedApplication);
        console.log("Application changed, creating ResultProgress...");

        chunkFunctions.value = useResultProgress(application, locale);
        console.log("ChunkFunctions:", chunkFunctions.value);
        console.log("ChunkFunctions.application:", chunkFunctions.value.application);
        chunkFunctions.value.showProgress = true;
        results.value.forEach((chunk, index) => {
          console.log(`Processing chunk ${index}:`, chunk);
          if (chunkFunctions.value.parseChunck) {
            chunkFunctions.value.parseChunck(chunk);
          }
        });
        console.log("All chunks processed. Progresses:", chunkFunctions.value.progresses);
      }
      else {
        console.error("No payload.results found!");
        message.value = "Aucune donnée de résultats trouvée.";
      }
    });
    return { chunkFunctions: computed(() => chunkFunctions.value) };
  },
};
</script>
